<template>
  <div class="container">
    <p class="disable-selection">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: "CustomLink",
  props: {
    label: String
  }
};
</script>

<style scoped>
p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
